/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthAdminRouteImport } from './routes/_auth/admin'
import { Route as AuthBulkRouteImport } from './routes/_auth/bulk'
import { Route as AuthCardsRouteImport } from './routes/_auth/cards'
import { Route as AuthOperationsRouteImport } from './routes/_auth/operations'
import { Route as AuthPhotosRouteImport } from './routes/_auth/photos'
import { Route as AuthHistoryIndexRouteImport } from './routes/_auth/history/index'
import { Route as AuthHistoryBatchIdRouteImport } from './routes/_auth/history/$batchId'
import { Route as AuthMeIndexRouteImport } from './routes/_auth/me/index'
import { Route as AuthPhotosIndexRouteImport } from './routes/_auth/photos/index'
import { Route as AuthUsersOidRouteImport } from './routes/_auth/users/$oid'
import { Route as AuthAdminDashboardIndexRouteImport } from './routes/_auth/admin/dashboard/index'
import { Route as AuthAdminLogsIndexRouteImport } from './routes/_auth/admin/logs/index'
import { Route as AuthAdminTemplatesIndexRouteImport } from './routes/_auth/admin/templates/index'
import { Route as AuthAdminTemplatesIdRouteImport } from './routes/_auth/admin/templates/$id'
import { Route as AuthAdminUsersIndexRouteImport } from './routes/_auth/admin/users/index'
import { Route as AuthPhotosBulkIndexRouteImport } from './routes/_auth/photos/bulk/index'
import { Route as AuthPhotosExportIndexRouteImport } from './routes/_auth/photos/export/index'
import { Route as AuthPhotosKioskIndexRouteImport } from './routes/_auth/photos/kiosk/index'
import { Route as AuthPhotosMeIndexRouteImport } from './routes/_auth/photos/me/index'
import { Route as AuthPhotosModerationIndexRouteImport } from './routes/_auth/photos/moderation/index'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBulkRoute = AuthBulkRouteImport.update({
  id: '/bulk',
  path: '/bulk',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCardsRoute = AuthCardsRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOperationsRoute = AuthOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPhotosRoute = AuthPhotosRouteImport.update({
  id: '/photos',
  path: '/photos',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHistoryIndexRoute = AuthHistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHistoryBatchIdRoute = AuthHistoryBatchIdRouteImport.update({
  id: '/history/$batchId',
  path: '/history/$batchId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeIndexRoute = AuthMeIndexRouteImport.update({
  id: '/me/',
  path: '/me/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPhotosIndexRoute = AuthPhotosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPhotosRoute,
} as any)
const AuthUsersOidRoute = AuthUsersOidRouteImport.update({
  id: '/users/$oid',
  path: '/users/$oid',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminDashboardIndexRoute = AuthAdminDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminLogsIndexRoute = AuthAdminLogsIndexRouteImport.update({
  id: '/logs/',
  path: '/logs/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminTemplatesIndexRoute = AuthAdminTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminTemplatesIdRoute = AuthAdminTemplatesIdRouteImport.update({
  id: '/templates/$id',
  path: '/templates/$id',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminUsersIndexRoute = AuthAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthPhotosBulkIndexRoute = AuthPhotosBulkIndexRouteImport.update({
  id: '/bulk/',
  path: '/bulk/',
  getParentRoute: () => AuthPhotosRoute,
} as any)
const AuthPhotosExportIndexRoute = AuthPhotosExportIndexRouteImport.update({
  id: '/export/',
  path: '/export/',
  getParentRoute: () => AuthPhotosRoute,
} as any)
const AuthPhotosKioskIndexRoute = AuthPhotosKioskIndexRouteImport.update({
  id: '/kiosk/',
  path: '/kiosk/',
  getParentRoute: () => AuthPhotosRoute,
} as any)
const AuthPhotosMeIndexRoute = AuthPhotosMeIndexRouteImport.update({
  id: '/me/',
  path: '/me/',
  getParentRoute: () => AuthPhotosRoute,
} as any)
const AuthPhotosModerationIndexRoute =
  AuthPhotosModerationIndexRouteImport.update({
    id: '/moderation/',
    path: '/moderation/',
    getParentRoute: () => AuthPhotosRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/bulk': typeof AuthBulkRoute
  '/cards': typeof AuthCardsRoute
  '/operations': typeof AuthOperationsRoute
  '/photos': typeof AuthPhotosRouteWithChildren
  '/history/$batchId': typeof AuthHistoryBatchIdRoute
  '/users/$oid': typeof AuthUsersOidRoute
  '/history/': typeof AuthHistoryIndexRoute
  '/me/': typeof AuthMeIndexRoute
  '/photos/': typeof AuthPhotosIndexRoute
  '/admin/templates/$id': typeof AuthAdminTemplatesIdRoute
  '/admin/dashboard/': typeof AuthAdminDashboardIndexRoute
  '/admin/logs/': typeof AuthAdminLogsIndexRoute
  '/admin/templates/': typeof AuthAdminTemplatesIndexRoute
  '/admin/users/': typeof AuthAdminUsersIndexRoute
  '/photos/bulk/': typeof AuthPhotosBulkIndexRoute
  '/photos/export/': typeof AuthPhotosExportIndexRoute
  '/photos/kiosk/': typeof AuthPhotosKioskIndexRoute
  '/photos/me/': typeof AuthPhotosMeIndexRoute
  '/photos/moderation/': typeof AuthPhotosModerationIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/bulk': typeof AuthBulkRoute
  '/cards': typeof AuthCardsRoute
  '/operations': typeof AuthOperationsRoute
  '/': typeof AuthIndexRoute
  '/history/$batchId': typeof AuthHistoryBatchIdRoute
  '/users/$oid': typeof AuthUsersOidRoute
  '/history': typeof AuthHistoryIndexRoute
  '/me': typeof AuthMeIndexRoute
  '/photos': typeof AuthPhotosIndexRoute
  '/admin/templates/$id': typeof AuthAdminTemplatesIdRoute
  '/admin/dashboard': typeof AuthAdminDashboardIndexRoute
  '/admin/logs': typeof AuthAdminLogsIndexRoute
  '/admin/templates': typeof AuthAdminTemplatesIndexRoute
  '/admin/users': typeof AuthAdminUsersIndexRoute
  '/photos/bulk': typeof AuthPhotosBulkIndexRoute
  '/photos/export': typeof AuthPhotosExportIndexRoute
  '/photos/kiosk': typeof AuthPhotosKioskIndexRoute
  '/photos/me': typeof AuthPhotosMeIndexRoute
  '/photos/moderation': typeof AuthPhotosModerationIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/admin': typeof AuthAdminRouteWithChildren
  '/_auth/bulk': typeof AuthBulkRoute
  '/_auth/cards': typeof AuthCardsRoute
  '/_auth/operations': typeof AuthOperationsRoute
  '/_auth/photos': typeof AuthPhotosRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/_auth/history/$batchId': typeof AuthHistoryBatchIdRoute
  '/_auth/users/$oid': typeof AuthUsersOidRoute
  '/_auth/history/': typeof AuthHistoryIndexRoute
  '/_auth/me/': typeof AuthMeIndexRoute
  '/_auth/photos/': typeof AuthPhotosIndexRoute
  '/_auth/admin/templates/$id': typeof AuthAdminTemplatesIdRoute
  '/_auth/admin/dashboard/': typeof AuthAdminDashboardIndexRoute
  '/_auth/admin/logs/': typeof AuthAdminLogsIndexRoute
  '/_auth/admin/templates/': typeof AuthAdminTemplatesIndexRoute
  '/_auth/admin/users/': typeof AuthAdminUsersIndexRoute
  '/_auth/photos/bulk/': typeof AuthPhotosBulkIndexRoute
  '/_auth/photos/export/': typeof AuthPhotosExportIndexRoute
  '/_auth/photos/kiosk/': typeof AuthPhotosKioskIndexRoute
  '/_auth/photos/me/': typeof AuthPhotosMeIndexRoute
  '/_auth/photos/moderation/': typeof AuthPhotosModerationIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/bulk'
    | '/cards'
    | '/operations'
    | '/photos'
    | '/history/$batchId'
    | '/users/$oid'
    | '/history/'
    | '/me/'
    | '/photos/'
    | '/admin/templates/$id'
    | '/admin/dashboard/'
    | '/admin/logs/'
    | '/admin/templates/'
    | '/admin/users/'
    | '/photos/bulk/'
    | '/photos/export/'
    | '/photos/kiosk/'
    | '/photos/me/'
    | '/photos/moderation/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/admin'
    | '/bulk'
    | '/cards'
    | '/operations'
    | '/'
    | '/history/$batchId'
    | '/users/$oid'
    | '/history'
    | '/me'
    | '/photos'
    | '/admin/templates/$id'
    | '/admin/dashboard'
    | '/admin/logs'
    | '/admin/templates'
    | '/admin/users'
    | '/photos/bulk'
    | '/photos/export'
    | '/photos/kiosk'
    | '/photos/me'
    | '/photos/moderation'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/admin'
    | '/_auth/bulk'
    | '/_auth/cards'
    | '/_auth/operations'
    | '/_auth/photos'
    | '/_auth/'
    | '/_auth/history/$batchId'
    | '/_auth/users/$oid'
    | '/_auth/history/'
    | '/_auth/me/'
    | '/_auth/photos/'
    | '/_auth/admin/templates/$id'
    | '/_auth/admin/dashboard/'
    | '/_auth/admin/logs/'
    | '/_auth/admin/templates/'
    | '/_auth/admin/users/'
    | '/_auth/photos/bulk/'
    | '/_auth/photos/export/'
    | '/_auth/photos/kiosk/'
    | '/_auth/photos/me/'
    | '/_auth/photos/moderation/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bulk': {
      id: '/_auth/bulk'
      path: '/bulk'
      fullPath: '/bulk'
      preLoaderRoute: typeof AuthBulkRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cards': {
      id: '/_auth/cards'
      path: '/cards'
      fullPath: '/cards'
      preLoaderRoute: typeof AuthCardsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/operations': {
      id: '/_auth/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof AuthOperationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/photos': {
      id: '/_auth/photos'
      path: '/photos'
      fullPath: '/photos'
      preLoaderRoute: typeof AuthPhotosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/history/': {
      id: '/_auth/history/'
      path: '/history'
      fullPath: '/history/'
      preLoaderRoute: typeof AuthHistoryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/history/$batchId': {
      id: '/_auth/history/$batchId'
      path: '/history/$batchId'
      fullPath: '/history/$batchId'
      preLoaderRoute: typeof AuthHistoryBatchIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/me/': {
      id: '/_auth/me/'
      path: '/me'
      fullPath: '/me/'
      preLoaderRoute: typeof AuthMeIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/photos/': {
      id: '/_auth/photos/'
      path: '/'
      fullPath: '/photos/'
      preLoaderRoute: typeof AuthPhotosIndexRouteImport
      parentRoute: typeof AuthPhotosRoute
    }
    '/_auth/users/$oid': {
      id: '/_auth/users/$oid'
      path: '/users/$oid'
      fullPath: '/users/$oid'
      preLoaderRoute: typeof AuthUsersOidRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/dashboard/': {
      id: '/_auth/admin/dashboard/'
      path: '/dashboard'
      fullPath: '/admin/dashboard/'
      preLoaderRoute: typeof AuthAdminDashboardIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/logs/': {
      id: '/_auth/admin/logs/'
      path: '/logs'
      fullPath: '/admin/logs/'
      preLoaderRoute: typeof AuthAdminLogsIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/templates/': {
      id: '/_auth/admin/templates/'
      path: '/templates'
      fullPath: '/admin/templates/'
      preLoaderRoute: typeof AuthAdminTemplatesIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/templates/$id': {
      id: '/_auth/admin/templates/$id'
      path: '/templates/$id'
      fullPath: '/admin/templates/$id'
      preLoaderRoute: typeof AuthAdminTemplatesIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/users/': {
      id: '/_auth/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthAdminUsersIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/photos/bulk/': {
      id: '/_auth/photos/bulk/'
      path: '/bulk'
      fullPath: '/photos/bulk/'
      preLoaderRoute: typeof AuthPhotosBulkIndexRouteImport
      parentRoute: typeof AuthPhotosRoute
    }
    '/_auth/photos/export/': {
      id: '/_auth/photos/export/'
      path: '/export'
      fullPath: '/photos/export/'
      preLoaderRoute: typeof AuthPhotosExportIndexRouteImport
      parentRoute: typeof AuthPhotosRoute
    }
    '/_auth/photos/kiosk/': {
      id: '/_auth/photos/kiosk/'
      path: '/kiosk'
      fullPath: '/photos/kiosk/'
      preLoaderRoute: typeof AuthPhotosKioskIndexRouteImport
      parentRoute: typeof AuthPhotosRoute
    }
    '/_auth/photos/me/': {
      id: '/_auth/photos/me/'
      path: '/me'
      fullPath: '/photos/me/'
      preLoaderRoute: typeof AuthPhotosMeIndexRouteImport
      parentRoute: typeof AuthPhotosRoute
    }
    '/_auth/photos/moderation/': {
      id: '/_auth/photos/moderation/'
      path: '/moderation'
      fullPath: '/photos/moderation/'
      preLoaderRoute: typeof AuthPhotosModerationIndexRouteImport
      parentRoute: typeof AuthPhotosRoute
    }
  }
}

interface AuthAdminRouteChildren {
  AuthAdminTemplatesIdRoute: typeof AuthAdminTemplatesIdRoute
  AuthAdminDashboardIndexRoute: typeof AuthAdminDashboardIndexRoute
  AuthAdminLogsIndexRoute: typeof AuthAdminLogsIndexRoute
  AuthAdminTemplatesIndexRoute: typeof AuthAdminTemplatesIndexRoute
  AuthAdminUsersIndexRoute: typeof AuthAdminUsersIndexRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminTemplatesIdRoute: AuthAdminTemplatesIdRoute,
  AuthAdminDashboardIndexRoute: AuthAdminDashboardIndexRoute,
  AuthAdminLogsIndexRoute: AuthAdminLogsIndexRoute,
  AuthAdminTemplatesIndexRoute: AuthAdminTemplatesIndexRoute,
  AuthAdminUsersIndexRoute: AuthAdminUsersIndexRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthPhotosRouteChildren {
  AuthPhotosIndexRoute: typeof AuthPhotosIndexRoute
  AuthPhotosBulkIndexRoute: typeof AuthPhotosBulkIndexRoute
  AuthPhotosExportIndexRoute: typeof AuthPhotosExportIndexRoute
  AuthPhotosKioskIndexRoute: typeof AuthPhotosKioskIndexRoute
  AuthPhotosMeIndexRoute: typeof AuthPhotosMeIndexRoute
  AuthPhotosModerationIndexRoute: typeof AuthPhotosModerationIndexRoute
}

const AuthPhotosRouteChildren: AuthPhotosRouteChildren = {
  AuthPhotosIndexRoute: AuthPhotosIndexRoute,
  AuthPhotosBulkIndexRoute: AuthPhotosBulkIndexRoute,
  AuthPhotosExportIndexRoute: AuthPhotosExportIndexRoute,
  AuthPhotosKioskIndexRoute: AuthPhotosKioskIndexRoute,
  AuthPhotosMeIndexRoute: AuthPhotosMeIndexRoute,
  AuthPhotosModerationIndexRoute: AuthPhotosModerationIndexRoute,
}

const AuthPhotosRouteWithChildren = AuthPhotosRoute._addFileChildren(
  AuthPhotosRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthBulkRoute: typeof AuthBulkRoute
  AuthCardsRoute: typeof AuthCardsRoute
  AuthOperationsRoute: typeof AuthOperationsRoute
  AuthPhotosRoute: typeof AuthPhotosRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
  AuthHistoryBatchIdRoute: typeof AuthHistoryBatchIdRoute
  AuthUsersOidRoute: typeof AuthUsersOidRoute
  AuthHistoryIndexRoute: typeof AuthHistoryIndexRoute
  AuthMeIndexRoute: typeof AuthMeIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthBulkRoute: AuthBulkRoute,
  AuthCardsRoute: AuthCardsRoute,
  AuthOperationsRoute: AuthOperationsRoute,
  AuthPhotosRoute: AuthPhotosRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
  AuthHistoryBatchIdRoute: AuthHistoryBatchIdRoute,
  AuthUsersOidRoute: AuthUsersOidRoute,
  AuthHistoryIndexRoute: AuthHistoryIndexRoute,
  AuthMeIndexRoute: AuthMeIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
